import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Language switcher controller connected")
  }

  switch(event) {
    // Optional: Add any custom logic before language switch
    // For example, saving state or showing a loading indicator
    console.log("Switching language...")
  }
}
